import React from 'react';

import {
  NavContainer,
  NavArrowContainer,
  NavArrow,
  PageNumber,
} from '@components/DataTable/DataTable.style';
import Icon from '@components/Icon/Icon';

interface PaginationFooterProps {
  page: number;
  changePage: (newPage: number) => void;
}

const PaginationFooter = ({ page, changePage }: PaginationFooterProps) => {
  const handlePageChange = (nav: number) => {
    const newPage = page + nav;
    if (newPage < 0) {
      return;
    }
    changePage(newPage);
  };

  return (
    <tfoot>
      <tr>
        <td>
          <NavContainer>
            <NavArrowContainer>
              <NavArrow onClick={() => handlePageChange(-1)}>
                <Icon color="text.primary" name="chevron-down" rotation={90} />
              </NavArrow>

              <PageNumber>{`Page ${page + 1}`}</PageNumber>

              <NavArrow onClick={() => handlePageChange(1)}>
                <Icon color="text.primary" name="chevron-down" rotation={-90} />
              </NavArrow>
            </NavArrowContainer>
          </NavContainer>
        </td>
      </tr>
    </tfoot>
  );
};

export default PaginationFooter;
